import { takeLeading } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { get } from 'lodash';
import { REQUEST_REJECTED_CLAIMS } from 'containers/ManagerRejectedClaimsPage/constants';
import { setRejectedClaims } from 'containers/ManagerRejectedClaimsPage/actions';
import userToken from 'containers/services/security/access-token-storage';

export function* requestRejectedClaims(action: any) {
  const { status, page, pageSize } = action;
  const token = get(userToken.get(), 'token');
  const path = `/corporeal/common/claims?status=${status}&page=${page}&pageSize=${pageSize}`;
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };
  yield callApi(path, {}, options, [], setRejectedClaims);
}

export function* requestRejectedClaimsSaga() {
  yield takeLeading(REQUEST_REJECTED_CLAIMS, requestRejectedClaims);
}

export default [requestRejectedClaimsSaga];
